"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
__exportStar(require("./schemas/base-error-response.schema"), exports);
__exportStar(require("./schemas/common.schema"), exports);
__exportStar(require("./schemas/consultation.schema"), exports);
__exportStar(require("./schemas/doctor.schema"), exports);
__exportStar(require("./schemas/nurse.schema"), exports);
__exportStar(require("./schemas/patient.schema"), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29tbW9uL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7QUFBQSx1RUFBcUQ7QUFDckQsMERBQXdDO0FBQ3hDLGdFQUE4QztBQUM5QywwREFBd0M7QUFDeEMseURBQXVDO0FBQ3ZDLDJEQUF5QyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCAqIGZyb20gJy4vc2NoZW1hcy9iYXNlLWVycm9yLXJlc3BvbnNlLnNjaGVtYSc7XG5leHBvcnQgKiBmcm9tICcuL3NjaGVtYXMvY29tbW9uLnNjaGVtYSc7XG5leHBvcnQgKiBmcm9tICcuL3NjaGVtYXMvY29uc3VsdGF0aW9uLnNjaGVtYSc7XG5leHBvcnQgKiBmcm9tICcuL3NjaGVtYXMvZG9jdG9yLnNjaGVtYSc7XG5leHBvcnQgKiBmcm9tICcuL3NjaGVtYXMvbnVyc2Uuc2NoZW1hJztcbmV4cG9ydCAqIGZyb20gJy4vc2NoZW1hcy9wYXRpZW50LnNjaGVtYSc7XG4iXX0=